import React from 'react';
import PropTypes from 'prop-types';
import PayoutsRow from './PayoutsRow';
import PayoutItems from './PayoutItems';
import CollapseElement from '../../elements-collapse/Collapse';
import Table from '../../elements-table/table';
import Button from '../../elements-buttons/Button';
import ModalManager from '../../elements-modal/modal-manager-v2';
import CsvModal from './CsvModal';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const PaidPayoutsTable = ({
  payouts,
  toggleModal,
  whichModal,
  ...props
}) => (
  <div>
    <div className="flex space-between">
      <h4>
        <FormattedMessage
          id="hosting.paid_payouts_table.processed_heading"
          defaultMessage="Processed"
        />
      </h4>
      <div>
        <Button
          buttonClassname="text-center"
          category="default"
          onClick={() => toggleModal('csvModal')}
          attributes={{ 'data-testing-id': 'download-csv' }}
          isLoading={false}
          className="btn-outlined-light"
        >
          <FormattedMessage
            id="hosting.paid_payouts_table.download_csv_button_text"
            defaultMessage="Download CSV"
          />
        </Button>
      </div>
    </div>
    <Table
      headerContainerClass="payouts-table-header"
      tableHeaders={
        [
          { label: <FormattedMessage id="hosting.paid_payouts_table.table_header_date" defaultMessage="Date"/>, classname: 'flex-basis-15 flex-basis-45-xxs' },
          { label: <FormattedMessage id="hosting.paid_payouts_table.table_header_status" defaultMessage="Status"/>, classname: 'flex-basis-15 status-header hidden-xs' },
          { label: <FormattedMessage id="hosting.paid_payouts_table.table_header_description" defaultMessage="Description"/>, classname: 'flex-basis-40 hidden-xxs' },
          { label: <FormattedMessage id="hosting.paid_payouts_table.table_header_items" defaultMessage="# of items"/>, classname: 'flex-basis-10 text-right hidden-xs' },
          { label: <FormattedMessage id="hosting.paid_payouts_table.table_header_amount" defaultMessage="Amount"/>, classname: 'flex-basis-15 text-right flex-basis-45-xxs' },
          { label: '', classname: 'flex-basis-5 flex-basis-10-xxs' }
        ]
      }
      tableBodyClass="payouts-table-body no-gutter"
      tableBody={
        payouts.map((payout) => {
          return (
            <CollapseElement
              key={payout.payout_id}
              buttonClassname="payouts-row btn-reset"
              buttonText={
                <PayoutsRow payout={payout} />
              }
            >
              <div>
                <PayoutItems payoutItems={payout.items || []} />
              </div>
            </CollapseElement>
          );
        })
      }
    />
    <ModalManager
      whichModal={get(props, 'modal.modalId', '')}
      toggleModal={toggleModal}
    >
      <CsvModal
        {...props}
        id="csvModal"
      />
    </ModalManager>
  </div>
);

PaidPayoutsTable.propTypes = {
  payouts: PropTypes.array.isRequired,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string
};

export default PaidPayoutsTable;
